<template>
  <div class="labels-initial-view">
    <section class="labels-initial-view__inner_wrapper">
      <div class="labels-initial-view__badges-preview">
        <Badge
          v-for="badge in graphicBadges"
          :key="badge.label"
          :label="badge.label"
          :size="badge.size"
          :color="badge.bgColor"
          :override-label-color="badge.textColor"
          :style="badge.style"
          class="labels-initial-view__badge"
        />
        <div class="labels-initial-view__badges-preview-gradient"></div>
      </div>
      <div class="labels-initial-view__content">
        <h2 class="labels-initial-view__title">Dataset Labels</h2>
        <p class="labels-initial-view__description">
          Use labels to organize datasets across your workspace
        </p>
      </div>

      <DarwinButton
        class="labels-initial-view__button"
        size="lg"
        kind="primary"
        flair="rounded"
        @click="emit('click:setup-labels')"
      >
        <template #icon-prepend>
          <Icon name="mono-plus" />
        </template>
        Setup Labels
      </DarwinButton>
    </section>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from 'vue'

import DarwinButton from '@/uiKit/Button/DarwinButton.vue'
import Icon from '@/uiKit/Icon/Icon.vue'
import Badge from '@/uiKit/Badge/Badge.vue'

const emit = defineEmits<{
  (e: 'click:setup-labels'): void
}>()

const graphicBadges = shallowRef([
  {
    label: 'Testing',
    size: 'small',
    bgColor: 'var(--color-background-rainbow-14)',
    textColor: 'var(--color-text-rainbow-14)',
    style: {
      transform: 'rotate(-2.566deg)',
      right: '38px',
      top: '22px',
    },
  },
  {
    label: 'Onboarding',
    size: 'medium',
    bgColor: 'hsl(214 95% 93%)',
    textColor: 'var(--color-text-selected)',
    style: {
      transform: 'rotate(3.54deg)',
      left: '20px',
      top: '38px',
    },
  },
  {
    label: 'New Project',
    size: 'large',
    bgColor: 'hsl(34 100% 92%)',
    textColor: 'var(--color-text-warning)',
    style: {
      transform: 'rotate(-4.502deg)',
      bottom: '5px',
      left: '48px',
    },
  },
])
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/spacings.scss';

.labels-initial-view {
  margin: auto;

  &__inner_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 234px;
  }

  &__badges-preview {
    position: relative;
    width: 177px;
    height: 96px;

    &-gradient {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 26px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    }
  }

  &__badge {
    position: absolute;
    pointer-events: none;
  }

  &__content {
    text-align: center;
    margin-block-start: $spacing-2;
  }

  &__title {
    @include typographyBoldBody700;
  }

  &__description {
    @include typographyRegularBody400;
    color: var(--color-text-subtlest);
  }

  &__button {
    margin-block-start: $spacing-5;
  }
}
</style>
